<template>
    <div>
        <modal v-model="priceListModal" :title="titlePriceListModal" @hide="resetPriceListModal" ref="modal" size="lg" id="modal-price-list">
            <div class="row">
                <div class="col-lg-3">
                    <div :class="[$v.priceList.code.required ? '' : 'has-error', 'form-group']">
                        <label class="control-label">Cód. da tabela {{$v.priceList.code.required ? '' : '*'}}</label>
                        <input v-model="priceList.code" type="text" class="form-control" placeholder="" >
                    </div>
                </div>
                <div class="col-lg-9">
                    <div :class="[$v.priceList.name.required ? '' : 'has-error', 'form-group']">
                        <label class="control-label">Nome da tabela {{$v.priceList.name.required ? '' : '*'}}</label>
                        <input v-model="priceList.name" type="text" class="form-control">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">
                    <div class="form-group">
                        <label class="control-label">Buscar</label>
                        <input v-model="search" type="text" class="form-control" placeholder="Busca por código, categoria ou procedimento...">
                    </div>
                </div>
                <div class="col-lg-4">
                    <btn type="primary" @click="batchAdjustmentModal = true" block style="margin-top: 24px"><i class="fa fa-align-justify"></i> Ajuste em lote <small>(somente valores em R$)</small></btn>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <table class="table table-striped table-bordered dt-responsive nowrap" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th width="5%"><input type="checkbox" v-model="checkAll"></th>
                                <th width="10%">Código</th>
                                <th width="20%">Categoria</th>
                                <th width="42%">Procedimento</th>
                                <th width="10%">R$/%</th>
                                <th width="13%">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(treatment, index) in priceList.treatments" :key="index">
                            <td><input type="checkbox" :value="treatment" v-model="checkedTreatments"></td>
                            <td>{{treatment.code}}</td>
                            <td>{{treatment.category.category_treatment}}</td>
                            <td>{{treatment.procedure}}</td>
                            <td>
                                <select class="form-control" v-model="treatment.unit">
                                    <option value="R$">R$</option>
                                    <option value="%">%</option>
                                </select>
                            </td>
                            <td>
                                <div class="form-group" v-if="treatment.unit === '%'"><input v-model="treatment.price" type="number" step="0.01" min="0" max="100" class="form-control"></div>
                                <currency-input v-else v-model="treatment.price" currency="BRL" :allow-negative="false" :auto-decimal-mode="true" :distraction-free="false"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div slot="footer">
                <btn @click="priceListModal=false">Cancelar</btn>
                <btn type="primary" @click="savePriceTable"><i class="fa fa-save" aria-hidden="true"></i> {{okTextPriceListModal}}</btn>
            </div>

            <modal v-model="batchAdjustmentModal" title="Reajustar todos os procedimentos selecionados" append-to-body ref="modal2" @hide="batchValue=0">
                <alert v-if="checkedTreatments.length < 2" type="warning"><p class="h5 d-flex align-items-center"><i class="fa fa-exclamation-triangle fa-3x" aria-hidden="true"></i> Você deve selecionar ao menos dois procedimentos para ajuste em lote.</p></alert>
                <div v-else>
                    <p class="text-center">{{ checkedTreatments.length }} procedimentos selecionados.</p>
                    <p class="text-center">Somente os procedimentos em reais serão reajustados.</p>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label class="control-label">Operação</label>
                                <select v-model="batchOperation" class="form-control">
                                    <option value="-">Desconto</option>
                                    <option value="+">Acréscimo</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div :class="[($v.batchValue.required && $v.batchValue.minValue) ? '' : 'has-error', 'form-group']">
                                <label class="control-label">Valor %</label>
                                <input v-model="batchValue" type="number" min="0" step="0.01" class="form-control">
                            </div>
                        </div>
                    </div>
                    </div>
                <div slot="footer">
                    <btn @click="batchAdjustmentModal=false">Cancelar</btn>
                    <btn type="primary" :disabled="!checkedTreatments.length" @click="batchAdjustmentPriceTable"><i class="fa fa-plus" aria-hidden="true"></i> Aplicar reajuste</btn>
                </div>
            </modal>

        </modal>

        <div class="panel panel-default">
            <div class="panel-heading">
                <div class="row" style="margin-bottom: -14px">
                    <div class='col-sm-3'>
                        <div class="form-group">
                            <button type="button" class="btn btn-info" @click="addPriceList"><i class="fa fa-plus" aria-hidden="true"></i> Nova tabela de preços</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="box box-default">
                    <div class="box-header with-border">
                        <i class="fa fa-stethoscope"></i>
                        <h3 class="box-title">Tabelas de preços</h3>
                    </div>
                    <div class="box-body">
                        <datatable-component search-placeholder-prop="Buscar..." ref="dataTables" class="mt-3"
                                             :columns-prop="columns"
                                             url-prop="/price/list/get/all"
                                             :tableDataSendRequestProp="{}"
                                             default-order-prop="code">
                            <template v-slot:action="data">
                                <li class="m-1" @click="editPriceList(data.data)"><a href="javascript:void(0)" title="Editar"><i class="fa fa-edit" aria-hidden="true"></i> Alterar</a></li>
                                <li class="m-1" @click="deletePriceList(data.data)"><a href="javascript:void(0)" title="Excluir"><i class="fa fa-trash" aria-hidden="true"></i> Excluir</a></li>
                            </template>
                        </datatable-component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DatatableComponent from '../datatable/datatable-component';
    import {required, minValue} from "vuelidate/lib/validators";
    import { CurrencyInput } from 'vue-currency-input'

    export default {
        name: "PriceList",

        components: { DatatableComponent, CurrencyInput },

        data() {
            return {
                optionsToast: { timeout: 6000, position: 'topCenter' },

                priceListModal: false,
                titlePriceListModal: '',
                okTextPriceListModal: '',
                batchAdjustmentModal: false,

                search: null,
                checkAll: false,
                checkedTreatments: [],
                batchOperation: '-',
                batchValue: 0,

                columns:[
                    { width: '5%', label: 'CÓDIGO.', name: 'code', sortable: true },
                    { width: '45%', label: 'NOME', name: 'name', type: 'String', sortable: true },
                    { width: '45%', label: 'STATUS', name: 'active', type: 'Bool', bool:{  true : 'Ativa', false: 'Inativa' }, sortable: true },
                    { width: '5%', label: 'AÇÃO', name: 'action', type: 'action', sortable: false },
                ],

                treatments: [],

                priceList:{
                    id: null,
                    code: null,
                    name: null,
                    active: true,
                    treatments: []
                }
            }
        },

        watch: {
            search: function (search, lastSearch) {
                this.priceList.treatments = [...this.treatments.filter(item => {
                    return (item.category.category_treatment || '').toLowerCase().indexOf((search || '').toLowerCase()) >= 0
                    || ((item.procedure || '').toLowerCase().indexOf((search || '').toLowerCase()) >= 0)
                    || ((item.code || '').toLowerCase().indexOf((search || '').toLowerCase()) >= 0)
                })]
            },

            checkAll: function (value, lastValue) {
                if(value) this.checkedTreatments = this.priceList.treatments;
                else this.checkedTreatments = []
            },
        },

        validations: {
            priceList:{
                code: { required },
                name: { required },
            },

            batchValue: {required, minValue: minValue(0)}
        },

        async mounted(){
                const treatmentsFromDb = await this.getTreatmentsFromDb()
                this.treatments = treatmentsFromDb
                this.priceList.treatments = treatmentsFromDb
        },

        methods: {
            async getTreatmentsFromDb(){
                try {
                    const response = await axios.post('/treatments/simple/get/all',{simpleGet:'true'});
                    return response.data.data
                } catch (error) {
                    console.log(error);
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }

            },

            addPriceList() {
                Object.assign(this.priceList.treatments,[...this.treatments])
                this.titlePriceListModal = 'Cadastrar nova tabela de preços'
                this.okTextPriceListModal = 'Cadastrar nova tabela de preços'
                this.priceListModal = true
            },

            async resetPriceListModal(msg){
                const treatmentsFromDb = await this.getTreatmentsFromDb()
                this.treatments = treatmentsFromDb
                this.search = null
                this.checkAll = false
                this.checkedTreatments = []
                this.priceList = {
                    id: null,
                    code: null,
                    name: null,
                    active: true,
                    treatments: treatmentsFromDb
                }
            },

            editPriceList(data) {
                this.priceList.id = data.id
                this.priceList.code = data.code
                this.priceList.name = data.name
                const treatments = [...data.treatments.map(function(treatments) {
                    treatments.unit = treatments.pivot.unit
                    treatments.price = treatments.pivot.value
                    return treatments;
                })]
                this.priceList.treatments = [...treatments]
                this.treatments = [...treatments];
                this.titlePriceListModal = 'Alterar tabela de preços'
                this.okTextPriceListModal = 'Alterar tabela de preços'
                this.priceListModal= true
            },

            async savePriceTable() {
                if (this.$v.$invalid) {
                    this.$toast.warning('Por favor revise os campos obrigatórios', 'Aviso', this.optionsToast);
                    return false
                }

                // const merge = (a, b) => a.filter( aa => ! b.find ( bb => aa.id === bb.id) ).concat(b);
                // this.priceList.treatments = merge(this.treatments, this.priceList.treatments)


                // const mergedArray = [...this.priceList.treatments, ...this.treatments];
                // // mergedArray have duplicates, lets remove the duplicates using Set
                // let set = new Set();
                // let unionArray = mergedArray.filter(item => {
                //     if (!set.has(item.id)) {
                //         set.add(item.id);
                //         return true;
                //     }
                //     return false;
                // }, set);
                // this.priceList.treatments = unionArray;

                try {
                    this.priceListModal = false
                    let response = {}
                    this.priceList.treatments = _.unionBy(this.priceList.treatments, this.treatments, "id")
                    if(this.priceList.id)
                        response = await axios.put('/price/list',this.priceList);
                    else
                        response = await axios.post('/price/list',this.priceList);

                    if(response.data.type == 'success'){
                        this.$refs.dataTables.reload()
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    } else if(response.data.type == 'warning'){
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                    }
                } catch (error) {
                    console.log(error);
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }
            },

            deletePriceList(data) {
                let self = this;
                this.$toast.question('Tem certeza que deseja excluir esta tabela de preços? Planos vinculados a ela assumirão a tabela modelo em seu lugar.<br>Esta operação é irreversível!','ATENÇÃO',{
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    toastOnce: true,
                    id: 'delete_' + data.id,
                    position: "center",
                    buttons: [
                        [
                            "<button><b>DELETAR TEBELA DE PREÇOS</b></button>",
                            function(instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast);
                                axios.delete('/price/list/' + data.id)
                                    .then(response => {
                                        if(response.data.type == 'success'){
                                            self.$refs.dataTables.reload();
                                            self.$toast.success(response.data.message, response.data.title, self.optionsToast);
                                        } else if(response.data.type == 'warning'){
                                            self.$toast.warning(response.data.message, response.data.title, self.optionsToast);
                                        } else {
                                            self.$toast.info(response.data.message, response.data.title, self.optionsToast);
                                        }
                                    }).catch(error => {
                                    console.log(error);
                                    if(error.response.status === 401 || error.response.status === 419){
                                        self.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', self.optionsToast);
                                    } else {
                                        self.$toast.error(error.response.data.message, 'Erro', self.optionsToast);
                                    }
                                })
                            },
                            true
                        ],
                        [
                            "<button>CANCELAR</button>",
                            function(instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast);
                            }
                        ]
                    ],
                })
            },

            batchAdjustmentPriceTable() {
                if (this.$v.batchValue.$invalid) {
                    this.$toast.warning('Por favor revise os campos obrigatórios', 'Aviso', this.optionsToast);
                    return false
                }
                this.checkedTreatments = this.checkedTreatments.map(function(treatments) {
                    if(treatments.unit === 'R$'){
                        const formula = (treatments.price * (this.batchValue/100).toFixed(2))
                        if(this.batchOperation === '-'){
                            treatments.price = (treatments.price - formula)
                        } else if (this.batchOperation === '+'){
                            treatments.price = (treatments.price + formula)
                        }
                    }
                    return treatments;
                }.bind(this));
                this.batchAdjustmentModal = false
            },

            formatMoney(amount, decimalCount = 2, decimal = ",", thousands = ".") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = amount < 0 ? "-" : "";

                    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.log(e)
                }
            },

        },
    }
</script>

<style scoped>

</style>